import React from 'react';
import { bool, shape, string } from 'prop-types';

const Discing = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 5C6.6 5 7.1 5.2 7.5 5.5C7.1 6.1 6.79961 6.8 6.59961 7.5C6.39965 7.2001 6.19996 7 6 7C5.3 7 4.2998 9.2 4.2998 12C4.2998 14.8 5.3 17 6 17C6.19996 17 6.39965 16.7999 6.59961 16.5C6.89961 17.3 7.2 17.9 7.5 18.5C7.1 18.8 6.6 19 6 19C3.5 19 2 15.8 2 12C2 8.2 3.5 5 6 5Z" fill="currentColor" />
    <path d="M11.8994 5C12.4993 5 12.9995 5.20013 13.3994 5.5C12.9995 6.09994 12.7 6.8001 12.5 7.5C12.3 7.2 12.0994 7 11.8994 7C11.1994 7.00102 10.2002 9.20065 10.2002 12C10.2002 14.7993 11.1994 16.999 11.8994 17C12.0994 17 12.3 16.8 12.5 16.5C12.7 17.2999 12.9995 17.9001 13.3994 18.5C12.9995 18.7999 12.4993 19 11.8994 19C9.62255 18.9996 8.17648 16.3448 7.93652 13H6.90039C6.30039 13 5.90039 12.6 5.90039 12C5.90039 11.4 6.40039 11 6.90039 11H7.93652C8.17648 7.65524 9.62255 5.00038 11.8994 5Z" fill="currentColor" />
    <path d="M18.2002 10.7998C18.6971 10.8001 19.0996 11.3374 19.0996 12C19.0995 12.6625 18.697 13.1999 18.2002 13.2002C17.7032 13.2002 17.2999 12.6627 17.2998 12C17.2998 11.3373 17.7031 10.7998 18.2002 10.7998Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M18.2002 5C20.8002 5 22.7002 8.2 22.7002 12C22.7002 15.8 20.9002 19 18.2002 19C15.832 19 14.045 16.345 13.7451 13H12.7002C12.1002 13 11.7002 12.6 11.7002 12C11.7002 11.4 12.2002 11 12.7002 11H13.7451C14.045 7.65498 15.832 5 18.2002 5ZM18.2002 7C17.0002 7 15.7002 9.2 15.7002 12C15.7002 14.8 17.0002 17 18.2002 17C19.4002 17 20.7002 14.8 20.7002 12C20.7002 9.2 19.4002 7 18.2002 7Z" fill="currentColor" />
  </svg>
);

Discing.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Discing;
